import { Link } from 'react-router-dom'
import posts from '../../../data/posts'
import Layout from '../../../components/layout'

function Astro() {
  const articles = posts.filter((p) => p.category === 'astro' && p.date && p.description)

  return (
    <div className="flex-grow bg-slate-900 text-slate-200">
      <Layout className="py-10">

        <div className="flex flex-row items-center">
          <div className="flex-grow h-[1px] bg-slate-700"></div>
          <div className="flex-grow-0 font-sans text-slate-300 font-medium flex pr-4 pl-4 md:text-3xl text-2xl">Astro</div>
          <div className="flex-grow h-[1px] bg-slate-700"></div>
        </div>

        <div className="flex flex-col items-center">
          <div className="w-full md:w-3/4">
            {articles.map((post) => (
              <div className="py-4" key={post.slug}>
                <Link to={`/blog/${post.category}/${post.slug}`} className="group">
                  <div className="
                    p-3 bg-slate-900
                    hover:-translate-y-[4px] transition-transform duration-300 ease-out
                    border border-transparent hover:border-teal-400 group-focus-visible:border-teal-400
                    shadow-[3px_3px_8px_rgba(20,184,166,0.2)]
                    hover:shadow-[5px_5px_12px_rgba(20,184,166,0.35)] group-focus-visible:shadow-[5px_5px_12px_rgba(20,184,166,0.35)]
                  ">
                    <div className="font-mono text-xs text-slate-500 pb-1">{post.categoryLabel} · {post.date}</div>
                    <div className="font-sans text-teal-300 font-medium md:text-xl text-lg pb-1">{post.title}</div>
                    <div className="font-sans text-slate-400 text-sm leading-relaxed">{post.description}</div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>

      </Layout>
    </div>
  )
}

export default Astro;
